export function download(uri: string, filename: string) {
    const a = document.createElement("a");
    a.href = uri;
    a.download = filename;
    a.click();
}

export function getFileTimeStamp() {
    return new Date(Date.now())
        .toLocaleString('en-gb')
        .replace(',', '')
        .replace(/[\/\:]/g, '_')
}